import { render, staticRenderFns } from "./ZnNewProject.vue?vue&type=template&id=0bbbfc86"
import script from "./ZnNewProject.vue?vue&type=script&lang=js"
export * from "./ZnNewProject.vue?vue&type=script&lang=js"
import style0 from "./ZnNewProject.vue?vue&type=style&index=0&id=0bbbfc86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports